import React, { useEffect, useRef, useState } from 'react';
import { FooterIconButton } from '../../base/buttons';
import { translate } from '../../base/i18n';
import { connect } from '../../base/redux';
import { getPropertyValue, updateSettings } from '../../base/settings';

let numClicks = 0;
let timeOut;

function usePrevious(value) {
    const ref = useRef();

    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

function SpeakerMutedButton({t, dispatch, initVolume, isMobile}) {
    const [volume, setVolume] = useState();
    const [isOff, setIsOff] = useState(true);
    const prevVolume = usePrevious(volume);

    useEffect(() => {
        if (initVolume === 0) {
            setIsOff(true);
        } else {
            setIsOff(false);
            setVolume(initVolume);
        }
    }, [initVolume]);

    const onClick = () => {
        numClicks++;

        switch (numClicks) {
            case 2:
                doDouble();
                break;
            case 1:
                timeOut = setTimeout(() => doSingle(), 200);
                break;
        }
    };

    const doSingle = () => {
        numClicks = 0;

        if (isOff) {
            dispatch(updateSettings({speakerVolume: prevVolume || 0.5}));
        } else {
            dispatch(updateSettings({speakerVolume: 0}));
        }
    };

    const doDouble = () => {
        clearTimeout(timeOut);
        numClicks = 0;
    };

    return (
        <>
            {!isMobile && <FooterIconButton mode="speaker" name={ t("device.speaker") } checked={!isOff} onClick={onClick} /> }
        </>
    );
}

function _mapStateToProps(state) {
    const initVolume = getPropertyValue(state, 'speakerVolume');

    return {
        initVolume,
    };
}

export default translate(connect(_mapStateToProps)(SpeakerMutedButton));
